import { render, staticRenderFns } from "./Misc.vue?vue&type=template&id=ed2048d4&scoped=true&lang=html&"
import script from "./Misc.vue?vue&type=script&lang=js&"
export * from "./Misc.vue?vue&type=script&lang=js&"
import style0 from "./Misc.vue?vue&type=style&index=0&id=ed2048d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2048d4",
  null
  
)

export default component.exports